import { Component, OnDestroy, OnInit } from '@angular/core';
import { LanguageTranslateService } from 'src/app/_services/language-translate.service';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { AuthenticationService } from 'src/app/auth/authentication.service';
import { FormGroup, FormControl, Validators} from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { ErrorUtil } from "src/app/_utilities/error";
import { Router } from "@angular/router";
import { SubscriptionUtil } from "src/app/_utilities/subscription";
import { FolderService } from "../../../../_services/folder.service";
import { ModalServiceService } from 'src/app/_services/modal-service.service';
import { UsersService } from 'src/app/_services/admin/users.service';
import { ReportService } from "src/app/_services/report.service";
import { OwnershipConfirmationPopupComponent } from '../ownership-confirmation-popup/ownership-confirmation-popup.component';

@Component({
    selector: 'app-add-edit-folder-tree',
    templateUrl: './add-edit-folder-tree.component.html',
    styleUrls: ['./add-edit-folder-tree.component.scss'],
    standalone: false
})
export class AddEditFolderTreeComponent extends SubscriptionUtil implements OnInit, OnDestroy {

  translate: any;
  data: any;
  currentFolder: any;
  buttonLabel: string = '';
  cancelButtonLabel: string = '';
  folderForm: FormGroup;
  header: string;
  maxLengthErrorMssg: string;
    users: any = [];
  user_groups: any = [];
  folder_access: any = [{
    name: 'Viewer',
    value: 'VIEWER',
    disabled: false
  },
  {
    name: 'Editor',
    value: 'EDITOR',
    disabled: false
  },
  {
    name: 'Owner',
    value: 'OWNER',
    disabled: false
  }];

  //folder access for user groups
  folder_access_group: any = [{
    name: 'Viewer',
    value: 'VIEWER'
  },
  {
    name: 'Editor',
    value: 'EDITOR'
  }];
  selected_users: any = [];
  selected_groups: any = [];
  isNextButtonClicked: boolean;
  title: string;
  module: string = '';
  isReportSharePossible: boolean = true; //variable to check user/group values for sharing report

  constructor(public modalRef: BsModalRef,private languageTranslateService: LanguageTranslateService, 
      private auth: AuthenticationService,private spinner: NgxSpinnerService, 
      private bsModalServc: BsModalService,
      private errorUtil: ErrorUtil,private route: Router, private folderServc: FolderService,
      private modalServc: ModalServiceService, private userService: UsersService, private reportService: ReportService
    ) {
    
    super(); 
  }

  ngOnInit(): void {
    this.languageTranslateService.wordSrc$.subscribe(transData => {
      if (Object.keys(transData).length != 0) {
        this.translate = transData;
        this.buttonLabel = this.translate?.general.buttons.next.singular;
        this.cancelButtonLabel = this.translate?.general.buttons.cancel.singular;
        this.title = this.translate?.report.messages.enterNameForFolder;
        this.maxLengthErrorMssg = this.translate?.report.validationFE.exceedCharacterLimit +' '+'(20)';
      }
    })

    this.header = this.data.modalType;
    this.module = this.data?.module;
    let nameValidators = [Validators.required, Validators.maxLength(20)]
    this.folderForm = new FormGroup({
      name: new FormControl('', this.header !== 'share' ? nameValidators : []),
      user: new FormControl([], []),
      user_group: new FormControl([], [])
    })

    this.currentFolder = this.data.nodeInfo ? this.data.nodeInfo?.name : 'root';

    if (this.header !== 'add'){
      if (this.data?.module == 'folder'){
        //folder sharing functions
        this.getSelectedFolder(); 
      }
      else{
        //report sharing functions
        this.getSelectedReport();
      }
    }
 
  };

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  onSubmit(){
    if (this.folderForm.valid){
      let user_list: any = [];
      let group_list: any = [];
      

      let folderInfo: any = {
        "name": this.folderForm.value.name,
        "type": "folder",
        "visible": true,
        "users": user_list,
        "userGroups": group_list,
        "parentFolder": this.data.nodeInfo ? {id : this.data.nodeInfo.id } : null
      };

      if (this.data.modalType == 'add'){
        this.selected_users.map( (user:any) => { 
          user_list.push({ user : {id: user.id}, accessType: this.folderForm.controls['access'+user.id].value});
        });
        
        this.selected_groups.map((group:any) => { 
          group_list.push({ userGroup: {id: group.id}, accessType: this.folderForm.controls['access_group'+group.id].value});
        });

        folderInfo.users = user_list;
        folderInfo.userGroups = group_list;
        this.folderServc.createFolder(folderInfo).subscribe( (res: any) => {
          //refresh the folder tree list
          if (res.status === 200){
            this.errorUtil.setErrorMessage(
              200,
              this.translate?.general.messages.createdSuccessfully,
              null,
              "success",
              2000
            );
            this.folderForm.reset();
            this.bsModalServc.setDismissReason('createFolder+'+res.body.id);
            this.modalRef.hide();
          }
        },
        (err: any)=>{
          console.log(err, 'err printing..')
          this.errorUtil.setErrorMessage(
            err.status,
            err.error ? err.error.title : null,
            err.error ? err.error.title : null,
            "error",
            2000
          );
        })
      }
      else{
        //rename/share folder
        this.selected_users.map( (user:any) => { 
          user_list.push({ user: {id: user.id}, accessType: this.folderForm.controls['access'+user.id].value });
        });
        
        this.selected_groups.map((group:any) => { 
          group_list.push({ userGroup: {id: group.id}, accessType: this.folderForm.controls['access_group'+group.id].value });
        });

        folderInfo.userGroups = group_list;
        folderInfo['id'] = this.data.nodeInfo.id;
        folderInfo.parentFolder = this.data.parentId ? {id : this.data.parentId } : null;

        //add the current logged in user info as owner
        let ownerUser: any = this.data.nodeInfo.users.find((u:any) => u.user.id === parseInt(this.auth.getUserId()));
        if (ownerUser){
          //ownerUser might be undefined if the current logged in user's access is EDITOR to the folder being shared
          user_list.push({ user: {id: ownerUser?.user?.id}, accessType: ownerUser?.accessType });
        }
        //When the owner assigns accessType as OWNER to any of the users in the shared list, the owner will automatically become Editor 
        /*check if the user_list has more than one owner. If yes, set the current owner as EDITOR*/
        let ownerCount: number = 0;
        user_list.map((u:any) => {
          if (u.accessType === 'OWNER') {
            ownerCount++;
          }
        });

        folderInfo.users = user_list;
        if (ownerCount > 1) {
          this.openOwnershipConfirmationPopup(user_list, ownerUser, folderInfo);
        }
        else{
          if (this.module == 'folder'){
            //rename or share the folder
            this.folderServc.updateFolder(folderInfo, this.header).subscribe( (res: any) => {
              //refresh the folder tree list
              if (res.status === 200){
                this.errorUtil.setErrorMessage(
                  200,
                  this.translate?.general.messages.updatedSuccessfully,
                  null,
                  "success",
                  2000
                );
                this.folderForm.reset();
                this.modalRef.hide();
              }
            },
            (err: any)=>{
                console.log(err, 'err printing..')
                this.errorUtil.setErrorMessage(
                  err.status,
                  err.error ? err.error.title : null,
                  err.error ? err.error.title : null,
                  "error",
                  2000
                );
            })
          }
          else{
            //share the report
            this.shareReport(folderInfo);
          }
        }
      }
   }
  }

  openOwnershipConfirmationPopup(user_list: any, ownerUser: any, folderInfo: any) {
    const config: ModalOptions = {
      class: 'modal-sm modal-dialog-centered',
      backdrop: true,
      ignoreBackdropClick: true,
      initialState: {
        title: 'Change Owner Confirmation',
        dataToPass: {
          id: 1,
          name: this.module,
          description: this.translate.report.messages.areYouSureWantToChangeOwnership + '?',
        }
      }
    };

    const ownershipModal = this.bsModalServc.show(OwnershipConfirmationPopupComponent, config);

    // --- BLUR SETUP ---
    const applyBlur = () => {
      document.body.classList.add('blur-background-modal');
    };
    const cleanup = () => document.body.classList.remove('blur-background-modal');

    // add the blur immediately
    applyBlur();

    // remove it once modal fully closes
    ownershipModal.onHidden?.subscribe(cleanup);
    // --- END BLUR SETUP ---

    ownershipModal.onHide.subscribe((res: any) => {
      if (res === 'saveOwnership') {
        user_list.forEach((u: any) => {
          if (u.user.id === ownerUser.user.id) u.accessType = 'EDITOR';
        });
        folderInfo.users = user_list;

        if (this.module === 'folder') {
          this.folderServc.updateFolder(folderInfo, this.header).subscribe(
            (apiRes: any) => {
              if (apiRes.status === 200) {
                this.errorUtil.setErrorMessage(
                  200,
                  this.translate?.general.messages.updatedSuccessfully,
                  null,
                  'success',
                  2000
                );
                this.folderForm.reset();
                this.modalRef.hide();
              }
            },
            (err: any) => {
              this.errorUtil.setErrorMessage(
                err.status,
                err.error?.title ?? null,
                err.error?.title ?? null,
                'error',
                2000
              );
            }
          );
        } else {
          this.shareReport(folderInfo);
        }
      } else {
        this.modalRef.hide();
      }
    });
  }

  
  onClickNext(){
    // Open share folder dialog
    this.isNextButtonClicked = true;
    if (this.header == 'add'){
      this.currentFolder = this.folderForm.value.name;
    }
    this.title = this.currentFolder + ' ' + this.translate?.report.sections.sec1.singular;
    this.cancelButtonLabel = this.translate?.general.buttons.back.singular;
    this.buttonLabel = this.translate?.general.buttons.save.singular;

    if (!this.users.length && !this.user_groups.length){
      this.getUsersList();
      this.getGroupList();
    }
    
  }

  
  getUsersList(){
   
     this.userService.getActiveUsers().subscribe((data: any) => {
      this.users = data;
      //logged in user should not be in the user list of sharing option
      this.users = this.users.filter ( (user: any) => user.id !== parseInt(this.auth.getUserId()) );
      //set the form values if the modalType is 'share/rename' to see the people who have been shared with
      if (this.header == 'share' || this.header == 'rename'){
        let users_formvalues: any = [];
        this.data.nodeInfo.users.map ((u:any) => {
         if (u.user.id !== parseInt(this.auth.getUserId())) {
            users_formvalues.push(u.user.id);
          }
        });
        this.folderForm.patchValue({
          user: users_formvalues
        });

        this.onUserChange();
      }      
    })
    //https://trial-api.fieldex.com/custella-0.0.1-SNAPSHOT/api/v4-1/get-all-users?startFrom=0&perPage=25&columnName=superVisor&sortOrder=desc
  }

  getGroupList(){
    
     this.userService.getAlluserGroup().subscribe((data: any) => {
        this.user_groups = data;
        //set the form values if the modalType is 'share/rename' to see the group who have been shared with
        if (this.header == 'share' || this.header == 'rename'){
          let user_groups_formvalues: any = this.data.nodeInfo.userGroups.map ((g:any) => g.userGroup.id);
          this.folderForm.patchValue({
            user_group: user_groups_formvalues
          });

          this.onGroupChange();
        }
    })
    //https://trial-api.fieldex.com/custella-0.0.1-SNAPSHOT/api/v4-1/get-all-users?startFrom=0&perPage=25&columnName=superVisor&sortOrder=desc
  }

  onUserChange(e?: any){
    //check if the removing user is OWNER. If yes, show error message and don't allow to remove
    if (e){
      let incomingValues = e.value;
      if (incomingValues.length < this.selected_users.length){
        //user removed
        if (this.folderForm.controls['access'+e.itemValue].value == 'OWNER'){
           this.errorUtil.setErrorMessage(
            "400",
            null,
            this.translate.report.validationFE.ownerNotAllowedRemoved,
            "warn",
            2000
          );

          const users_formvalues = this.selected_users.map((item: any) => {
            return item.id
          }); 
          //patch the form value back cox p-multiselect already removed in the form field
          this.folderForm.patchValue({
            user: users_formvalues
          });

          return;
        }
      }

    }

    let formValues: any = this.folderForm.controls['user'].value;
    this.selected_users = this.users.filter((user: any) => formValues.includes(user.id));

    //for report sharing, user must select either user/group
    // if (this.module == 'report'){
    //   if (this.selected_users.length > 0 || this.selected_groups.length > 0){
    //     //if users or groups are selected, enable the Save button
    //     this.isReportSharePossible = true;
    //   }
    //   else{
    //     this.isReportSharePossible = false;
    //   }
    // }

    //only 10 users are allowed to add at a time
    if (this.selected_users.length > 10){
      this.errorUtil.setErrorMessage(
        "400",
        null,
        this.translate.report.validationFE.onlyTenUsersAddAtTime,
        "warn",
        2000
      );

      let newFormValues: any = formValues.slice(0, 10);
      this.folderForm.patchValue({
        user: newFormValues
      });

      this.selected_users = this.selected_users.filter((user: any) => newFormValues.includes(user.id));
      return;
    }

    let countOwner: number = 0;

    this.selected_users.map ((sel_user: any) =>{
      sel_user['folder_access']= [{
        name: this.translate.report.fields.viewer.singular,
        value: 'VIEWER',
        disabled: false
      },
      {
        name: this.translate.report.fields.editor.singular,
        value: 'EDITOR',
        disabled: false
      },
      {
        name: this.translate.report.fields.owner.singular,
        value: 'OWNER',
        disabled: false
      }];

      //count how many users are OWNER
      if (this.folderForm.controls['access'+sel_user.id] && this.folderForm.controls['access'+sel_user.id].value == 'OWNER'){
        countOwner++;
      }
      return {...sel_user}
    });
    
    this.selected_users.map((user:any, index: number)=>{
      let control: any = this.folderForm.get('access'+user.id);
      if (!control){
        this.folderForm.addControl('access'+user.id, new FormControl(null, Validators.required));

        if (!e){
          //set the access type accordingly from the data (for viewing purpose) (if the function is called in getUsersList())
          let matchedUser: any = this.data.nodeInfo.users.find((u:any) => u.user.id === user.id);
          this.folderForm.controls['access'+user.id].setValue(matchedUser ? matchedUser.accessType : '');
          if (matchedUser.accessType === 'OWNER') {
            this.folderForm.controls['access'+user.id].disable();
          }
          //apply the disable login for OWNER option
          this.onAccessChange({value: matchedUser.accessType}, user, index);
        }
        else{
          //disable OWNER option for other users (if user is changed from dropdown event)
          user.folder_access.map( (fa: any) => {
            if (fa.value === 'OWNER'){
              if (user.id == parseInt(this.auth.getUserId()) ){
                fa.disabled = true;
              }
              else if (this.data.nodeInfo.accessType == 'EDITOR'){
                //if current logged in user is not OWNER, disable OWNER option for other users
                fa.disabled = true;
              }
              else if (countOwner >= 1){
                //if ONE OWNER is already existed in the selected users list, disable OWNER option for other users
                fa.disabled = true;
              }
              else{
                fa.disabled = false;
              }
            }
            return {...fa}
          })
        }
      }

    })

    // if (this.header !== 'rename'){
    //   //if user is selected, group is optional. Only either one user or group needs to be selected (ONLY FOR SHARE)
    //   if (this.selected_users.length > 0){
    //     this.folderForm.controls['user_group'].clearValidators();
    //     this.folderForm.controls['user_group'].updateValueAndValidity();
    //   }
    //   else{
    //     //if no user is selected
    //     this.folderForm.controls['user_group'].setValidators(Validators.required);
    //     this.folderForm.controls['user_group'].updateValueAndValidity();
    //   }
    // }

    //disable the OWNER option during folder creation (ticket CS-6968)
    if (this.header == 'add'){
      //during folder creation, disable the OWNER option. OWNER option is only enable when sharing folder
      this.selected_users.map((user:any)=>{
        user.folder_access[2].disabled = true;

        return {...user}
      });
    }
    
    //remove unnecessary form controls from form
    for (var key in this.folderForm.controls){
      //check for form controls in selected users list
      if (key.startsWith('access') && key.substring(6) !== '_'){
        let keyString: string[] = key.split('access');
        let keyID: number = parseInt(keyString[1]);
        if (!formValues.includes(keyID)){
          //remove the form control if it does not exist in the selected users list
          this.folderForm.removeControl('access'+keyID);
        }
      }
    }

  }

  onGroupChange(e?: any){
    let formValues: any = this.folderForm.controls['user_group'].value;
    this.selected_groups = this.user_groups.filter((group: any) => formValues.includes(group.id));

    //for report sharing, user must select either user/group
    // if (this.module == 'report'){
    //   if (this.selected_users.length > 0 || this.selected_groups.length > 0){
    //     //if users or groups are selected, enable the Save button
    //     this.isReportSharePossible = true;
    //   }
    //   else{
    //     this.isReportSharePossible = false;
    //   }
    // }

    if (this.selected_groups.length > 10){
      this.errorUtil.setErrorMessage(
        "400",
        null,
        this.translate.report.validationFE.onlyTenGroupsAddAtTime,
        "warn",
        2000
      );

      let newFormValues: any = formValues.slice(0, 10);
      this.folderForm.patchValue({
        user_group: newFormValues
      });
      
      this.selected_groups = this.selected_groups.filter((g: any) => newFormValues.includes(g.id));

      return;
    }
    
    this.selected_groups.map((group:any)=>{
      let control: any = this.folderForm.get('access_group'+group.id);
      if (!control){
        this.folderForm.addControl('access_group'+group.id, new FormControl(null, Validators.required));

         if (!e){
          //set the access type of the group accordingly from the data (for viewing purpose)
          let matchedGroup: any = this.data.nodeInfo.userGroups.find((g:any) => g.userGroup.id === group.id);
          this.folderForm.controls['access_group'+group.id].setValue(matchedGroup ? matchedGroup.accessType : '');
        }
      }
    })

    // if (this.header !== 'rename'){
    //   //if group is selected, user is optional. Only either one user or group needs to be selected
    //   if (this.selected_groups.length > 0){
    //     this.folderForm.controls['user'].clearValidators();
    //     this.folderForm.controls['user'].updateValueAndValidity();
    //   }
    //   else{
    //     //if no group is selected
    //     this.folderForm.controls['user'].setValidators(Validators.required);
    //     this.folderForm.controls['user'].updateValueAndValidity();
    //   }
    // }

    //remove unnecessary form controls from form
    for (var key in this.folderForm.controls){
      //check for form controls in selected groups list
      if (key.startsWith('access_group')){
        let keyString: string[] = key.split('access_group');
        let keyID: number = parseInt(keyString[1]);
        if (!formValues.includes(keyID)){
          //remove the form control if it does not exist in the selected groups list
          this.folderForm.removeControl('access_group'+keyID);
        }
      }
    }
  }

  onCancelClick(){
    if (this.isNextButtonClicked && this.header == 'add'){
      //go back. don't hide modal
      this.isNextButtonClicked = false;
      this.cancelButtonLabel = this.translate?.general.buttons.cancel.singular;
      this.buttonLabel = this.translate?.general.buttons.next.singular;
      this.title = this.translate?.report.messages.enterNameForFolder;
      this.currentFolder = this.data.nodeInfo ? this.data.nodeInfo?.name : '';
    }
    else{
      //hide modal
      this.modalRef.hide()
    }
  }

  onGroupDelete(group: any, index: number){
    let formValues: any = this.folderForm.controls['user_group'].value;
    this.selected_groups.splice(index, 1);
    //form index is different from selected_groups index
    formValues.forEach ((f:any, formIndex: number) =>{
      if ( this.selected_groups.findIndex ((sg: any) => {return sg.id === f}) >= 0 ){
        //if found, keep. Remove otherwise
      }
      else{
        formValues.splice(formIndex, 1);
      }
    })
    
    this.folderForm.controls['user_group'].setValue(formValues);
    this.folderForm.removeControl('access_group'+group.id);
  }

  onUserDelete(user: any, index: number){
    let formValues: any = this.folderForm.controls['user'].value;
    this.selected_users.splice(index, 1);

    //form index is different from selected_users index
    formValues.forEach ((f:any, formIndex: number) =>{
      if ( this.selected_users.findIndex ((su: any) => {return su.id === f}) >= 0 ){
        //if found, keep. Remove otherwise
      }
      else{
        formValues.splice(formIndex, 1);
      }
    })
    
    this.folderForm.controls['user'].setValue(formValues);
    this.folderForm.removeControl('access'+user.id);
  }

  getSelectedFolder(){
    this.folderServc.getFolderById(this.data.nodeInfo?.id).subscribe((folder: any) => {
      this.data.nodeInfo['users'] = folder.body.users;
      this.data.nodeInfo['userGroups'] = folder.body.userGroups;

      if (this.header == 'rename'){
        //if the modal is open for editing the folder name
        this.folderForm.patchValue({
          name: this.currentFolder
        });
        this.buttonLabel = this.translate?.general.buttons.save.singular;
        this.getUsersList();
        this.getGroupList();
      }
      else if (this.header == 'share'){
        //if the modal is open for sharing the folder
        this.folderForm.patchValue({
          name: this.currentFolder,
        });

        //this.folderForm.controls['user_group'].setValidators(Validators.required);
        //this.folderForm.controls['user'].setValidators(Validators.required);

        //open the share dialog
        this.onClickNext();
        this.cancelButtonLabel = this.translate?.general.buttons.cancel.singular;
      }
      else{}

    },
    (err: any)=>{
      console.log(err, 'err printing..')
      this.errorUtil.setErrorMessage(
        err.status,
        err.error ? err.error.title : null,
        err.error ? err.error.title : null,
        "error",
        2000
      );
    });
  }

  getSelectedReport(){
    this.reportService.geReportById(this.data.nodeInfo?.id).subscribe((folder: any) => {
      this.data.nodeInfo['users'] = folder.body.users;
      this.data.nodeInfo['userGroups'] = folder.body.userGroups;

      if (this.header == 'share'){
          //if the modal is open for sharing the report
          this.folderForm.patchValue({
            name: this.currentFolder,
          });
          //open the share dialog
          this.onClickNext();
          this.cancelButtonLabel = this.translate?.general.buttons.cancel.singular;
         // this.isReportSharePossible = false;
        
      }
      else{}

    },
    (err: any)=>{
      console.log(err, 'err printing..')
      this.errorUtil.setErrorMessage(
        err.status,
        err.error ? err.error.title : null,
        err.error ? err.error.title : null,
        "error",
        2000
      );
    });
  }

  onAccessChange(event: any, user: any, index: number){
    //if one user is already OWNER, disable the OWNER option for others
    if ( event.value === 'OWNER'){
      this.selected_users.map ((u: any, i: number) =>{
        if (u.id !== user.id ){
          //disable OWNER option for other users
          u.folder_access.map( (fa: any) => {
            if (fa.value === 'OWNER'){
              fa.disabled = true;
            }
            return {...fa}
          })
        }
      })
    }
    else{
      //reset the options to enable the OWNER option for others ONLY FOR SHARE MODE
      if (this.header !== 'add'){
        this.selected_users.map ((u: any, i: number) =>{
          if (u.id !== user.id ){
            //enable OWNER option for other users
            u.folder_access.map( (fa: any) => {
              if (fa.value === 'OWNER'){
                fa.disabled = false;
              }
              return {...fa}
            })
          }
        })
      }
    }
  }

  shareReport(reportParams: any){
    delete reportParams.type;
    delete reportParams.visible;
    delete reportParams.parentFolder;
    
    this.reportService.shareReport(reportParams).subscribe( (res: any) => {
      //refresh the report list
      if (res.status === 200){
        this.errorUtil.setErrorMessage(
          200,
          this.translate?.general.messages.updatedSuccessfully,
          null,
          "success",
          2000
        );
        this.folderForm.reset();
        this.modalRef.hide();
      }
    },
    (err: any)=>{
        console.log(err, 'err printing..')
        this.errorUtil.setErrorMessage(
          err.status,
          err.error ? err.error.title : null,
          err.error ? err.error.title : null,
          "error",
          2000
        );
    })
  }

  onFolderNameChange(){
    if (this.folderForm.controls['name'].errors?.maxlength){
      this.folderForm.controls['name'].markAsTouched();
    }
  }

  onDropdownHide(datasetDD: any){
    if (datasetDD.resetFilter) {
      datasetDD.resetFilter();
      return;
    }

    datasetDD.filterValue = '';
    datasetDD.updateVisibleOptions && datasetDD.updateVisibleOptions();
    datasetDD.filterViewChild?.nativeElement && (datasetDD.filterViewChild.nativeElement.value = '');
  }
}
